import { useState } from 'react';
import { CashInBankInterCompanyDropdown } from 'components/CashInBankInterCompanyDropdown';
import { InterCompanyPaymentDate } from 'components/PaymentDatePicker/InterCompanyPaymentDate';
import { useFetchCashInBankInterCompany, useFetchOpenGlCalendars } from 'hooks';
import { CashCompany } from './CashCompany';
import { CashDisbursementsJournal } from './CashDisbursementsJournal';
import { InterCompanyPostingDescription } from './InterCompanyPostingDescription';
import {
  StyledColumn,
  StyledInterCompany,
  StyledInterCompanyDatePicker
} from './styled';
import { InterCompanyFieldsProps } from './types';

export const InterCompanyFields = ({
  setSelectedCashCompany,
  setSelectedCashInBank,
  setSelectedJournal,
  setPostingDesc,
  selectedCashCompany,
  postingDescription,
  isPostingDescriptionRequired
}: InterCompanyFieldsProps): React.JSX.Element => {
  const [, setPaymentDateError] = useState<boolean>(false);
  const { data: openGlCalendarsData } = useFetchOpenGlCalendars() || {};
  const { data, isLoading: isCashLoading } =
    useFetchCashInBankInterCompany(false);

  return (
    <StyledInterCompany>
      <StyledColumn>
        <CashCompany
          cashCompanies={data?.cashCompanies}
          isLoading={isCashLoading}
          setSelectedCashCompany={setSelectedCashCompany}
        />
        <CashInBankInterCompanyDropdown
          cashAccounts={data?.cashAccounts}
          selectedCashCompany={selectedCashCompany}
          isLoading={isCashLoading}
          setSelectedCashInBank={setSelectedCashInBank}
        />
        <CashDisbursementsJournal
          disbursementJournals={data?.disbursementJournals}
          isLoading={isCashLoading}
          selectedCashCompany={selectedCashCompany}
          setSelectedJournal={setSelectedJournal}
        />
      </StyledColumn>
      <StyledColumn>
        <InterCompanyPostingDescription
          setPostingDesc={setPostingDesc}
          postingDescription={postingDescription}
          isPostingDescriptionRequired={isPostingDescriptionRequired}
        />
        <StyledInterCompanyDatePicker>
          <InterCompanyPaymentDate
            glCalendarData={openGlCalendarsData}
            setError={setPaymentDateError}
          />
        </StyledInterCompanyDatePicker>
      </StyledColumn>
    </StyledInterCompany>
  );
};
